import { render } from "./ListDetailModal.vue?vue&type=template&id=2b09a246&scoped=true"
import script from "./ListDetailModal.vue?vue&type=script&lang=js"
export * from "./ListDetailModal.vue?vue&type=script&lang=js"

import "./ListDetailModal.vue?vue&type=style&index=0&id=2b09a246&scoped=true&lang=css"

import exportComponent from "/home/django/v1/mintit-engineer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b09a246"]])

export default __exports__